import React from "react";
import Grid from "@mui/material/Grid2";
import ServicesTable from "./ServicesTable";

function Services() {
  return (
    <>
      <Grid size={12}>
        <ServicesTable />
      </Grid>
    </>
  );
}

export default Services;
